import { __awaiter, __generator } from "tslib";
import { nativeRequest } from '@tencent/ark-request';
var ClientProxy = /** @class */ (function () {
    function ClientProxy() {
    }
    ClientProxy.send = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var reqPromise, timeoutPromise;
            return __generator(this, function (_a) {
                reqPromise = new Promise(function (resolve) {
                    var _a;
                    if ((_a = window === null || window === void 0 ? void 0 : window.tdocs) === null || _a === void 0 ? void 0 : _a.clientDatabaseRequest) {
                        window.tdocs
                            .clientDatabaseRequest(req)
                            .then(resolve)
                            .catch(function (err, code) {
                            resolve({
                                err_code: code,
                                err_msg: err,
                            });
                        });
                    }
                    else {
                        nativeRequest.invoke({
                            schema: 'jsapi',
                            namespace: 'docx',
                            method: 'clientDatabaseRequest',
                            params: req,
                            removeCallback: true,
                            callback: function (resp) {
                                resolve(resp);
                            },
                        });
                    }
                });
                timeoutPromise = new Promise(function (resolve) {
                    setTimeout(function () {
                        resolve({ err_msg: 'req timeout', err_code: ClientProxy.timeoutErrorCode });
                    }, ClientProxy.timeout);
                });
                return [2 /*return*/, Promise.race([reqPromise, timeoutPromise])];
            });
        });
    };
    ClientProxy.timeout = 10 * 1000;
    ClientProxy.timeoutErrorCode = '100002';
    return ClientProxy;
}());
export { ClientProxy };
//# sourceMappingURL=client-proxy.js.map